<template>
    <v-card :class="`book-data${breakpoint ? '-breakpoint': ''}`" elevation="2">
      <v-card-title>{{ bookData.title }}</v-card-title>

      <v-card-text>
        <p>{{ bookData.description }}</p>
        <p> {{ message }} </p>
        <v-layout wrap>
          <chapter-list />
        </v-layout>
      </v-card-text>

    </v-card>
</template>

<script>
import ChapterList from './chapterList/index.vue';

export default {
  components: { ChapterList },
  props: {
    bookData: {
      required: true,
    },

    chapters: {
      type: Array,
      required: true,
    },
  },

  computed: {
    breakpoint() {
      return !this.$vuetify.breakpoint.mdAndUp;
    },
  },

  data: () => ({
    message: 'Este site disponibiliza o livro em PDF para download e também acesso aos seguintes capítulos e funcionalidades:',
  }),
};
</script>

<style scoped>

  .book-data {
    margin-right: 30px;
    margin-left: -30px;
    padding-left: 30px;
    z-index: 2;
    text-align: justify;
  }

  .book-data-breakpoint {
    text-align: justify;
  }

</style>
